import { render, staticRenderFns } from "./LastRedirect.vue?vue&type=template&id=68be82b5&"
import script from "./LastRedirect.vue?vue&type=script&lang=js&"
export * from "./LastRedirect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports